export default function ChartIconSvg(props: any) {
  return (
    <svg
      className="waiting-result"
      width="71px"
      height="71px"
      viewBox="0 0 71 71"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Page 1</title>
      <desc>Created with Sketch.</desc>
      <defs></defs>
      <g id="waiting-result" transform="translate(-686.000000, -678.000000)">
        <g transform="translate(670.000000, 662.000000)">
          <polygon
            className="poly-chart"
            points="0 0 100 0 100 100 0 100"
          ></polygon>
          <path
            className="path-chart"
            d="M41.6666667,83.3333333 L58.3333333,83.3333333 L58.3333333,16.6666667 L41.6666667,16.6666667 L41.6666667,83.3333333 L41.6666667,83.3333333 Z M16.6666667,83.3333333 L33.3333333,83.3333333 L33.3333333,50 L16.6666667,50 L16.6666667,83.3333333 L16.6666667,83.3333333 Z M66.6666667,37.5 L66.6666667,83.3333333 L83.3333333,83.3333333 L83.3333333,37.5 L66.6666667,37.5 L66.6666667,37.5 Z"
          ></path>
        </g>
      </g>
    </svg>
  );
}
